import { useState } from 'react'
import { addHours, subHours } from 'date-fns'

import { DEFAULT_TIME_ZONE } from '../../../../constants/date'
import {
  createNowDateInUkTimezone,
  transposeToUkTimezoneDate,
} from '../../../../utils/date'
import { mockApiCall } from '../../../../utils/mock'
import {
  TaskStatusType,
  TaskTableItemCommitType,
  TaskTableRowDeadline,
  TaskTableRowDoneStatus,
  TaskTableRowPriority,
  TaskTableRowRequest,
  TaskTableRowTitle,
  TaskTableRowVisibility,
  TaskTableRowYesNoStatus,
} from '../../../Task'
import { Container } from '../../Container'
import { getTableRowData } from '../Tasks.mocks'

import * as styles from './TasksTableRowComponents.module.css'

const DEADLINE_DATE_FUTURE = transposeToUkTimezoneDate(
  'July 1, 2222, 12:00:00',
  DEFAULT_TIME_ZONE
)
const DEADLINE_DATE_OVERDUE = subHours(
  createNowDateInUkTimezone(DEFAULT_TIME_ZONE),
  1
)
const DEADLINE_DATE_TODAY = addHours(
  createNowDateInUkTimezone(DEFAULT_TIME_ZONE),
  1
)

function TasksTableRowComponents() {
  const [done, setDone] = useState(false)
  const [yesNo, setYesNo] = useState(null)
  const [visible, setVisible] = useState(false)
  const [isLoading, setLoading] = useState(false)

  function apiCall(value) {
    return mockApiCall({
      value,
      onInit: () => setLoading(true),
      onResolve: () => setLoading(false),
    })
  }

  function handleChangeDone({ done }) {
    return mockApiCall(done).then(response => {
      setDone(response)
    })
  }

  function handleChangeYesNo({ yesno }) {
    return apiCall(yesno).then(response => {
      setYesNo(response)
    })
  }

  function handleChangeVisibility({ visible_to_tenant }) {
    return apiCall(visible_to_tenant).then(response => {
      setVisible(response)
    })
  }

  return (
    <>
      <Container label='Task table row, status cell, type - done'>
        <div className={styles.cellContainer}>
          <TaskTableRowDoneStatus
            className={styles.cell}
            isLoading={isLoading}
            item={getTableRowData({ done })}
            onChange={handleChangeDone}
          />
        </div>
      </Container>
      <Container label='Task table row, status cell, type - done, permant loading'>
        <div className={styles.cellContainer}>
          <TaskTableRowDoneStatus
            isLoading
            className={styles.cell}
            item={getTableRowData({ done })}
          />
        </div>
      </Container>
      <Container label='Task table row, status cell, type - done, disabled'>
        <div className={styles.cellContainer}>
          <TaskTableRowDoneStatus
            disabled
            className={styles.cell}
            item={getTableRowData({ done: true })}
            onChange={handleChangeDone}
          />
        </div>
      </Container>
      <Container label='Task table row, status cell, type - yes\no'>
        <div className={styles.cellContainer}>
          <TaskTableRowYesNoStatus
            className={styles.cell}
            isLoading={isLoading}
            item={getTableRowData({
              commit_type: TaskTableItemCommitType.YesNo,
              yesno: yesNo,
            })}
            onChange={handleChangeYesNo}
          />
        </div>
      </Container>
      <Container label='Task table row, status cell, type - yes\no, disabled, No selected'>
        <div className={styles.cellContainer}>
          <TaskTableRowYesNoStatus
            disabled
            className={styles.cell}
            item={getTableRowData({
              commit_type: TaskTableItemCommitType.YesNo,
              yesno: TaskStatusType.No,
            })}
          />
        </div>
      </Container>
      <Container label='Task table row, title cell, done state'>
        <div className={styles.cellContainer}>
          <TaskTableRowTitle
            className={styles.cell}
            item={getTableRowData({ notes: null })}
          />
        </div>
        <div className={styles.cellContainer}>
          <TaskTableRowTitle
            className={styles.cell}
            item={getTableRowData({ done: true, notes: null })}
          />
        </div>
      </Container>
      <Container label='Task table row, title cell full data, done state'>
        <div className={styles.cellContainer}>
          <TaskTableRowTitle
            className={styles.cell}
            item={getTableRowData({
              counters: {
                active_automations: 5,
                error_messages: 5,
                files: 5,
                messages: 5,
                unread_messages: 5,
              },
            })}
          />
        </div>
        <div className={styles.cellContainer}>
          <TaskTableRowTitle
            className={styles.cell}
            item={getTableRowData({
              counters: {
                active_automations: 5,
                error_messages: 5,
                files: 5,
                messages: 5,
                unread_messages: 5,
              },
              done: true,
            })}
          />
        </div>
      </Container>
      <Container label='Task table row, visibility cell'>
        <div className={styles.cellContainer}>
          <TaskTableRowVisibility
            className={styles.cell}
            isLoading={isLoading}
            item={getTableRowData({ visible_to_tenant: visible })}
            onChange={handleChangeVisibility}
          />
        </div>
      </Container>
      <Container label='Task table row, deadline cell, OK'>
        <div className={styles.cellContainer}>
          <TaskTableRowDeadline
            className={styles.cell}
            item={getTableRowData({
              deadline: DEADLINE_DATE_FUTURE,
            })}
          />
        </div>
      </Container>
      <Container label='Task table row, deadline cell, overdue'>
        <div className={styles.cellContainer}>
          <TaskTableRowDeadline
            className={styles.cell}
            item={getTableRowData({
              deadline: DEADLINE_DATE_OVERDUE,
            })}
          />
        </div>
      </Container>
      <Container label='Task table row, deadline cell, today'>
        <div className={styles.cellContainer}>
          <TaskTableRowDeadline
            className={styles.cell}
            item={getTableRowData({
              deadline: DEADLINE_DATE_TODAY,
            })}
          />
        </div>
      </Container>
      <Container label='Task table row, deadline cell, done'>
        <div className={styles.cellContainer}>
          <TaskTableRowDeadline
            className={styles.cell}
            item={getTableRowData({ done: true })}
          />
        </div>
      </Container>
      <Container label='Task table row, priority cell'>
        <div className={styles.cellContainer}>
          <TaskTableRowPriority
            className={styles.cell}
            item={getTableRowData()}
          />
        </div>
      </Container>
      <Container label='Task table row, service request cell'>
        <div className={styles.cellContainer}>
          <TaskTableRowRequest
            className={styles.cell}
            item={getTableRowData()}
          />
        </div>
      </Container>
      <Container label='Task table row, service request cell, node'>
        <div className={styles.cellContainer}>
          <TaskTableRowRequest
            className={styles.cell}
            item={getTableRowData({ done: true })}
          />
        </div>
      </Container>
    </>
  )
}

export default TasksTableRowComponents
